/* 🤖 this file was generated by svg-to-ts */
export const siriusQuestionDuotone: {
  name: 'question_duotone';
  data: string;
} = {
  name: 'question_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="currentColor"/><path d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25Zm1.125-3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm2.25-6.75a3.375 3.375 0 0 1-2.625 3.29v.085a.75.75 0 1 1-1.5 0v-.75A.75.75 0 0 1 12 12a1.875 1.875 0 1 0-1.875-1.875.75.75 0 1 1-1.5 0 3.375 3.375 0 1 1 6.75 0Z" fill="currentColor"/></svg>`
};
